
import ApiService from '@/services/api.service'

export default {
	methods: {
		/**
		 * idTokenが有効か確認
		 * @return {Object} d レスポンス
		 */
		async $_apiMixin_getUsersMe () {
			const endpoint = apiService.endpoint('/users/me')
			const idToken = this.$auth.idToken || ''
			const option = apiService.setBearerOption(idToken)
			const d = await apiService.get(endpoint, option)
			return d
		},
		/**
		 * 購入履歴を取得
		 * @return {Object} d レスポンス
		 */
		async $_apiMixin_getPurchaseHistory () {
			const endpoint = apiService.endpoint('/users/me/purchase-history')
			const idToken = this.$auth.idToken || ''
			const option = apiService.setBearerOption(idToken)
			const d = await apiService.get(endpoint, option)
			return d
		},
		/**
		 * 支払いのためのセッションIDを取得
		 * @param {Object} body POSTのbody
		 * @return {Object} d レスポンス
		 */
		async $_apiMixin_postStripeSession (body) {
			const endpoint = apiService.endpoint('/users/me/stripe-session')
			const idToken = this.$auth.idToken || ''
			const option = apiService.setBearerOption(idToken)
			const d = await apiService.post(endpoint, body, option)
			return d
		},
		/**
		 * 商品一覧の情報を取得
		 * @return {Object} d レスポンス
		 */
		async $_apiMixin_getProducts () {
			const endpoint = apiService.endpoint('/products')
			const idToken = this.$auth.idToken || ''
			const option = apiService.setBearerOption(idToken)
			const d = await apiService.get(endpoint, option)
			return d
		},
		/**
		 * 合計金額の税込/税抜きを取得
		 * @return {Object} d レスポンス
		 */
		async $_apiMixin_postTotalPrice (body) {
			const endpoint = apiService.endpoint('/total-price')
			const idToken = this.$auth.idToken || ''
			const option = apiService.setBearerOption(idToken)
			const d = await apiService.post(endpoint, body, option)
			return d
		}
	}
}

const apiService = new ApiService()
